/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Shot_Changes_SuccessInputs */



/**
* | output |
* | --- |
* | "Snap To shot changes finished successfully" |
*
* @param {Snap_To_Shot_Changes_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_shot_changes_success = /** @type {((inputs?: Snap_To_Shot_Changes_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Shot_Changes_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alignement sur les changements de plan terminé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Snap-to-Aufnahmewechsel erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifiche di Snap To shot completate con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменения в снимок Snap To успешно завершены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los cambios en la toma Ajustar a se finalizaron correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照更改已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スナップ ショットの変更が正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्नैप टू शॉट में किए गए बदलाव सफलतापूर्वक पूरे हो गए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As alterações de disparo do Snap To foram concluídas com sucesso.")
	return /** @type {LocalizedString} */ ("Snap To shot changes finished successfully")
});